var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"modal-overlay",on:{"click":_vm.closeModal}},[_c('div',{staticClass:"modal-content"},[_c('img',{staticClass:"modal-image rounded w-[700px]",attrs:{"src":_vm.src,"alt":_vm.alt}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }